import { FormFieldsConfig } from 'pages/components/Form/FormEntities';

const PersonalInfosConfig = {
  gender: {
    default: 'm',
    constraints: ['required'],
    options: [
      {
        label: 'male',
        value: 'm',
      },
      {
        label: 'female',
        value: 'f',
      },
    ],
  },
  language: {
    default: 'fr',
    constraints: ['required'],
    options: [
      {
        label: 'french',
        value: 'fr',
      },
      {
        label: 'english',
        value: 'en',
      },
    ],
  },
  firstName: {
    constraints: ['required'],
    formatter: 'capitalizeWords',
  },
  lastName: {
    constraints: ['required'],
    formatter: 'capitalizeWords',
  },

  birthDate: {
    default: '',
    constraints: [
      'required',
      'ageDate',
    ],
  },

  externalIdentifier: {
    default: '',
    constraints: ['required', 'externalIdentifier'],
  },
} as FormFieldsConfig;

export default PersonalInfosConfig;
